// Extract entry price from trade
export const getEntryValue = (trade) => {
  if (!trade) return 0;

  if (trade.entry_price_type === "FLAT") {
    return parseFloat(trade.entry_price) || 0;
  }

  const from = parseFloat(trade.entry_price_from) || 0;
  const to = parseFloat(trade.entry_price_to) || 0;

  if (from > 0 && to > 0) return (from + to) / 2;

  return 0;
};

const asNumber = (v) => {
  if (v === "" || v == null) return NaN;
  const n = Number(String(v).replace(/[^0-9.]/g, ""));
  return isNaN(n) ? NaN : n;
};

// StopLoss → StopLoss%
export const stopLossToPercent = (entry, stopLoss) => {
  entry = Number(entry);
  const sl = asNumber(stopLoss);
  if (!entry || isNaN(sl)) return "";
  const p = Math.abs(((sl - entry) / entry) * 100);
  return p.toFixed(2);
};

// StopLoss% → StopLoss
export const percentToStopLoss = (entry, percent, orderType = "BUY") => {
  entry = Number(entry);
  const p = asNumber(percent);
  if (!entry || isNaN(p)) return "";
  // BUY ⇒ SL below ; SELL ⇒ SL above
  const sl =
    orderType === "SELL" ? entry * (1 + p / 100) : entry * (1 - p / 100);
  return sl.toFixed(2);
};

// Target → Profit%
export const targetToProfitPercent = (entry, target) => {
  entry = Number(entry);
  const tgt = asNumber(target);
  if (!entry || isNaN(tgt)) return "";
  const p = Math.abs(((tgt - entry) / entry) * 100);
  return p.toFixed(2);
};

// -------------------------------
// Profit% → Target Price
// (handles "-", "+", "-5", "+10")
// -------------------------------
export const percentToTarget = (entry, percent, orderType = "BUY") => {
  entry = Number(entry);
  const p = asNumber(percent);
  if (!entry || isNaN(p)) return "";
  // BUY ⇒ target above ; SELL ⇒ target below
  const tgt =
    orderType === "SELL" ? entry * (1 - p / 100) : entry * (1 + p / 100);
  return tgt.toFixed(2);
};

export const calculateExpectedProfit = ({ entry, target, lot, orderType }) => {
  entry = parseFloat(entry);
  target = parseFloat(target);
  lot = parseFloat(lot);

  if (!entry || !target || !lot) {
    return { expected: "", profitPercent: "" };
  }

  let expected = 0;
  let profitPercent = 0;

  if (orderType === "SELL") {
    expected = (entry - target) * lot;
    profitPercent = ((entry - target) / entry) * 100;
  } else {
    expected = (target - entry) * lot;
    profitPercent = ((target - entry) / entry) * 100;
  }

  return {
    expected: expected.toFixed(2),
    profitPercent: profitPercent.toFixed(2),
  };
};
